/* eslint-disable */
import { get, shuffle } from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';
import twitter from '@/components/twitter/twitter';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { ONBOARDING_STEPS } from '@/components/onboarding/consts';
import accountLogin from '@/components/cms/account-combined-login/account-combined-login.vue';
import marketListItemEmbed from '@/components/cms/market-list-item-v2-embed/market-list-item-v2-embed.vue';
import marketContractListEmbed from '@/components/cms/market-contract-list-v2-embed/market-contract-list-v2-embed.vue';
import marketContractListEmbedCompact from '@/components/cms/market-contract-list-v2-embed-compact/market-contract-list-v2-embed-compact.vue';
import documentTableView from '@/components/cms/document-table-view/document-table-view.vue';
import documentTileView from '@/components/cms/document-tile-view/document-tile-view.vue';
import linkComponent from '@/components/generics/link/link.vue';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import podcastsComponent, { PODCAST } from '@/components/home/home-old/podcasts/podcasts.vue';
import videoView from '@/components/cms/video-view/video-view.vue';
import store from '@/store';
import accountVerifyMixin from '@/mixins/accountVerify';
import router from '@/router/index';

const LoginComponent = Vue.extend(accountLogin);
const CollapsiblePanelComponent = Vue.extend(collapsiblePanel);
const MarketListItemEmbedComponent = Vue.extend(marketListItemEmbed);
const MarketContractListEmbedComponent = Vue.extend(marketContractListEmbed);
const MarketContractListEmbedCompactComponent = Vue.extend(marketContractListEmbedCompact);
const LinkComponent = Vue.extend(linkComponent);
const PodcastsComponent = Vue.extend(podcastsComponent);
const MarketChartsComponent = Vue.extend(marketCharts);
const DocumentTableViewComponent = Vue.extend(documentTableView);
const DocumentTileViewComponent = Vue.extend(documentTileView);
const VideoViewComponents = Vue.extend(videoView);

let PreviewCarouselEmbedComponent = null;
const getPreviewCarouselEmbedComponent = () => {
  if (PreviewCarouselEmbedComponent) {
    return PreviewCarouselEmbedComponent;
  }
  const module = require('@/components/cms/preview-carousel-embed/preview-carousel-embed.vue');
  PreviewCarouselEmbedComponent = Vue.extend(module.default || module);
  return PreviewCarouselEmbedComponent;
};

const dateGoDisplay = (dt) => {
  const daysDiff = moment().diff(dt, 'days');
  const hoursDiff = moment().diff(dt, 'hours');
  if (daysDiff > 365) {
    const years = Math.floor(daysDiff / 365);
    return (years === 1) ? '1 year ago' : `${years} years ago`;
  } else if (daysDiff > 30) {
    const months = Math.floor(daysDiff / 30);
    return (months === 1) ? '1 month ago' : `${months} months ago`;
  } else if (hoursDiff > 24) {
    return (daysDiff === 1) ? '1 day ago' : `${daysDiff} days ago`;
  } else if (hoursDiff >= 1) {
    return (hoursDiff === 1) ? '1 hour ago' : `${Math.floor(hoursDiff)} hours ago`;
  }
  return 'Within the last hour';
};

export default {
  mixins: [
    accountVerifyMixin,
  ],
  data() {
    return {
      content: '',
      marketTileMarkets: [],
      contractListMarkets: [],
      cmsAccordionContentObjects: [],
      podcastItemContentObjects: [],
      chartWidgetObjects: [],
      docsWidgetObjects: [],
      videoWidgetObjects: [],
      cmsChartMarketCache: new Map(),
    };
  },
  methods: {
    installCarousels() {
      const carousels = this.$el.querySelectorAll('.predictit__carousel');
      const PreviewCarouselComponent = getPreviewCarouselEmbedComponent();
      for (const el of carousels) {
        const indicesString = el.getAttribute('data-carousel_indices');
        const indexes = indicesString ? indicesString.split(',').map(i => i.trim()) : [];

        const instance = new PreviewCarouselComponent({
            parent: this,
            propsData: {
              indexes: indexes,
            },
          });
        instance.$mount(el);
      }
    },
    installAccordions() {
      const accordionHeaders = this.$el.querySelectorAll('.predictit__accordion');
      for (const el of accordionHeaders) {
        const uuid = el.getAttribute('data-accordionuuid');
        const title = el.getAttribute('data-accordiontitle');
        const accordionObj = this.cmsAccordionContentObjects.find(i => i.regionUUID === uuid);

        if (accordionObj) {
          const content = accordionObj.content || '';
          const instance = new CollapsiblePanelComponent({
            parent: this,
            propsData: {
              title,
              content,
              isOpen: accordionObj.isOpenByDefault,
            },
          });
          instance.$mount(el);
        }
      }
    },
    installTweets() {
      twitter().ready((twt) => {
        const twitterWidgets = this.$el.querySelectorAll('.predictit__twitter');
        for (const widget of twitterWidgets) {
          const tweetId = widget.getAttribute('data-tweetid');
          twt.widgets.createTweet(
            tweetId,
            widget,
            {
              theme: 'light',
            },
          );
        }
      });
    },
    installDateElapsed() {
      const dateEls = this.$el.querySelectorAll('.predictit__elapsedtime');
      for (const el of dateEls) {
        const date = moment(el.getAttribute('data-publishdate'));
        el.innerHTML = dateGoDisplay(date);
      }
    },
    installWelcomePopupControls() {
      const buttons = this.$el.querySelectorAll('.predictit-leaving-button');
      for (const button of buttons) {
        button.addEventListener('click', () => {
          store.dispatch('popup/setCurrentPopup', MODALS.LEAVING_POPUP);
        });
      }
    },
    installLoginAndSignUpControls() {
      const loginButtons = this.$el.querySelectorAll('.predictit-login-button');
      for (const button of loginButtons) {
        button.addEventListener('click', () => {
          if (store.getters['user/isLoggedIn']) {
            router.push({ name: 'market-list' });
          } else {
            store.dispatch('popup/setCurrentPopup', MODALS.LOGIN);
          }
        });
      }
      const loginControls = this.$el.querySelectorAll('.predictit-login-control');
      for (const button of loginControls) {
        if (store.getters['user/isLoggedIn']) {
          router.push({ name: 'market-list' });
        } else {
          const instance = new LoginComponent({
            parent: this,
            propsData: {},
          });
          instance.$mount(button);
        }
      }

      const signUpButtons = this.$el.querySelectorAll('.predictit-signup-button');
      for (const button of signUpButtons) {
        button.addEventListener('click', () => {
          if (store.getters['user/isLoggedIn']) {
            router.push({ name: 'market-list' });
          } else {
            store.dispatch('popup/setCurrentPopup', MODALS.REGISTER);
          }
        });
      }
    },
    installMarketLists() {
      const marketListEls = this.$el.querySelectorAll('.predictit__markettilelist');

      for (const el of marketListEls) {
        const marketIds = el.getAttribute('data-marketids').replace(' ', '').split(',').map(i => parseInt(i, 10));
        const markets = marketIds
          .map(marketId => this.marketTileMarkets.find(i => i.marketId === marketId))
          .filter(i => !!i);
        const dataNumColumns = parseInt(el.getAttribute('data-num-columns') || 3, 10);
        const renderStyle = parseInt(el.getAttribute('data-render-style') || 1, 10);

        if (markets.length > 0) {
          const instance = new MarketListItemEmbedComponent({
            parent: this,
            propsData: {
              markets,
              dataNumColumnsDesktop: dataNumColumns,
              renderStyle,
            },
          });
          instance.$mount(el);
        }
      }
    },
    installMarketContracts() {
      const marketContractsEl = this.$el.querySelectorAll('.predictit__marketpreview');
      for (const el of marketContractsEl) {
        const marketId = parseInt(el.getAttribute('data-marketid'), 10);
        const market = this.contractListMarkets.find(i => i.marketId === marketId);
        if (!market) {
          continue
        }
        const contractIds = el.getAttribute('data-contractids').replace(' ', '').split(',').map(i => parseInt(i, 10));
        const contracts = market.contracts.filter(i => contractIds.includes(i.contractId));
        const compactViewMode = (el.getAttribute('data-compactview') || '').toLowerCase() === 'true';
        const openNewTab = (el.getAttribute('data-opennewtab') || '').toLowerCase() === 'true';
        if (compactViewMode) {
          const instance = new MarketContractListEmbedCompactComponent({
            parent: this,
            propsData: {
              openNewTab,
              contracts: contracts.map((i) => {
                return {
                  ...i,
                  marketName: market.marketName,
                  marketId: market.marketId,
                }
              })
            },
          });
          instance.$mount(el);
        } else {
          const instance = new MarketContractListEmbedComponent({
            parent: this,
            propsData: {
              openNewTab,
              market: {
                ...market,
                contracts: [...contracts],
              },
            },
          });
          instance.$mount(el);
        }
      }
    },
    installButtonsAndLinks() {
      const links = this.$el.querySelectorAll('[data-buttontype="Link"]');
      for (const el of links) {
        const url = el.getAttribute('data-detailpath');
        const isStoryFooterCta = (el.getAttribute('data-story-footer-cta') || '').toLowerCase() === 'true';
        const instance = new LinkComponent({
          parent: this,
          propsData: {
            type: 'link',
            text: el.innerHTML,
            url,
            styleVariant: isStoryFooterCta ? 'story-footer-cta' : '',
          },
        });
        instance.$mount(el);
      }

      const buttons = this.$el.querySelectorAll('[data-buttontype="Button"]');
      for (const el of buttons) {
        const url = el.getAttribute('data-detailpath');
        const instance = new LinkComponent({
          parent: this,
          propsData: {
            type: 'button',
            text: el.innerHTML,
            url,
          },
        });
        instance.$mount(el);
      }
    },
    installPodcasts() {
      const podcastSliders = this.$el.querySelectorAll('.predictit__podcastslider');
      for (const el of podcastSliders) {
        const podcastUuids = (el.getAttribute('data-podcastuuids') || '')
          .split(',')
          .map(i => i.trim())
          .filter(i => i.length > 0);
        const podcasts = podcastUuids.map(index => this.podcastItemContentObjects.find(podcast => podcast.regionUUID === index)).filter(i => !!i);
        const title = el.getAttribute('data-podcasttitle');
        const isRandomized = (el.getAttribute('data-podcastisrandomized') || '').toLowerCase() === 'true';

        let items = podcasts.map((i) => {
          const chunks = (i.podcastUrl || '').split('/').filter(chunk => chunk && chunk.length > 0);
          return {
            id: chunks[chunks.length - 1] || '',
            type: PODCAST.APPLE,
          };
        }).filter(i => i.id.length > 0);

        if (isRandomized) {
          items = shuffle(items);
        }
        const forceLayoutMode = (typeof this.getCmsForcedLayoutMode === 'function')
          ? this.getCmsForcedLayoutMode()
          : '';
        const instance = new PodcastsComponent({
          parent: this,
          propsData: {
            theme: 'story',
            title,
            items,
            forceLayoutMode,
          },
        });
        instance.$mount(el);
      }
    },
    resolveChartMarket(marketId) {
      const normalizedMarketId = parseInt(marketId, 10);
      if (isNaN(normalizedMarketId)) {
        return Promise.reject(new Error(`Invalid market id: ${marketId}`));
      }

      if (this.cmsChartMarketCache.has(normalizedMarketId)) {
        return this.cmsChartMarketCache.get(normalizedMarketId);
      }

      const request = store.dispatch('market/getMarket', { marketId: normalizedMarketId, modifyState: false })
        .then((market) => {
          if (!market) {
            throw new Error(`Market data not found for marketId=${normalizedMarketId}`);
          }
          return market;
        })
        .catch((error) => {
          this.cmsChartMarketCache.delete(normalizedMarketId);
          throw error;
        });

      this.cmsChartMarketCache.set(normalizedMarketId, request);
      return request;
    },
    installMarketCharts(rootEl = null, { suppressGlobalLoader = false } = {}) {
      const root = rootEl || this.$el;
      if (!root) {
        return;
      }
      const marketChartsEl = root.querySelectorAll('.predictit__datachart');
      for (const el of marketChartsEl) {
        const mountState = el.getAttribute('data-cms-chart-mounted');
        if (mountState === 'pending' || mountState === 'true') {
          continue;
        }

        const uuid = el.getAttribute('data-chartuuid');
        const versionId = el.getAttribute('data-chartstoryversionid');
        const storyId = el.getAttribute('data-chartstoryid');
        const maxHeight = el.getAttribute('data-max-height');

        const chartObj = this.chartWidgetObjects.find(i => i.regionUUID === uuid);
        if (typeof chartObj === 'undefined') {
          continue
        }

        el.setAttribute('data-cms-chart-mounted', 'pending');
        this.resolveChartMarket(chartObj.marketId)
          .then((market) => {
            let result = {...market};
            if (chartObj.contractIds && result && result.contracts) {
              result = {
                ...result,
                contracts: result.contracts.filter(i => chartObj.contractIds.includes(i.contractId)),
              };
            }
            const instance = new MarketChartsComponent({
              parent: this,
              propsData: {
                market: result,
                chartOptions: {
                  ...chartObj,
                  cmsStoryId: storyId,
                  cmsVersionId: versionId,
                  includeDownload: false,
                  maxHeight,
                  // showContractImagesOnLegend: true,
                  // showContractImagesOnChart: true,
                },
                suppressGlobalLoader,
              },
            });
            instance.$mount(el);
            el.setAttribute('data-cms-chart-mounted', 'true');
          })
          .catch(() => {
            el.removeAttribute('data-cms-chart-mounted');
          })
      }
    },
    installVideoWidgets() {
      const videoEls = this.$el.querySelectorAll('.predictit__videowidget');
      for (const el of videoEls) {
        const url = el.getAttribute('data-videourl')
        const maxHeight = el.getAttribute('data-max-height');
        const videoData = this.videoWidgetObjects.find(i => i.videoUrl === url);
        const instance = new VideoViewComponents({
          parent: this,
          propsData: {
            ...videoData,
            maxHeight
          },
        })
        instance.$mount(el);
      }
    },
    installDocumentsWidgets() {
      const documentsEls = this.$el.querySelectorAll('.predictit__docswidget');
      for (const el of documentsEls) {
        const uuid = el.getAttribute('data-docsuuid')
        const viewType = parseInt(el.getAttribute('data-docsviewtype'), 10);
        const documentData = this.docsWidgetObjects.find(i => i.regionUUID === uuid);
        if (documentData) {
          const componentClassMap = {
            1: DocumentTileViewComponent,
            2: DocumentTableViewComponent
          }
          const ComponentClass = componentClassMap[viewType] || DocumentTileViewComponent
          const instance = new ComponentClass({
            parent: this,
            propsData: {
              documentData,
            },
          });
          instance.$mount(el);
        }
      }
    },
    installDynamicControls({
      data = {},
      marketChartsRootEl = null,
      suppressMarketChartsGlobalLoader = false,
      skipMarketCharts = false,
      skipCarousel = false,
    } = {}) {
      this.css = get(data, 'renderedCSS', '') || '';
      this.content = `${this.css}${get(data, 'renderedHTML', '')}`;
      this.cmsAccordionContentObjects = get(data, 'cmsContentObject.accordionContentObjects', []);
      this.podcastItemContentObjects = get(data, 'cmsContentObject.podcastItemContentObjects', []);
      this.contractListMarkets = get(data, 'cmsContentObject.contractListMarkets', []);
      this.marketTileMarkets = get(data, 'cmsContentObject.marketTileMarkets', []);
      this.chartWidgetObjects = get(data, 'cmsContentObject.chartWidgetObjects', []);
      this.docsWidgetObjects = get(data, 'cmsContentObject.docsWidgetObjects', []);
      this.videoWidgetObjects = get(data, 'cmsContentObject.videoWidgetObjects', []);

      this.$nextTick(() => {
        this.installAccordions();
        this.installTweets();
        this.installDateElapsed();
        this.installLoginAndSignUpControls();
        this.installWelcomePopupControls();
        this.installMarketLists();
        this.installMarketContracts();
        this.installButtonsAndLinks();
        this.installPodcasts();
        if (!skipMarketCharts) {
          this.installMarketCharts(marketChartsRootEl, { suppressGlobalLoader: suppressMarketChartsGlobalLoader });
        }
        this.installDocumentsWidgets();
        this.installVideoWidgets();
        if (!skipCarousel) {
          this.installCarousels();
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/cmsContent.js